// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import singleSpaVue from "single-spa-vue";
import App from "./App";
import router from "./router";
import store from "./store";
import MailerCloud from "./plugins/mailer-cloud";
import Mixins from "./plugins/mixins";
import BootstrapVue from "bootstrap-vue";
// import * as Sentry from "@sentry/vue";
// import DDBuilder from 'dd-builder'
import VueLocalStorage from "vue-localstorage";
import VueMeta from "vue-meta";

import VueAnalytics from "vue-analytics";
import VueTagManager from "vue-tag-manager";
import RoutePrefetch from "vue-router-prefetch";
import singleSpaCss from "single-spa-css";
//import Gleap from "gleap";

// Please make sure to call this method only once!
//import { setYandex } from "@/common/yandex";
import { initializeGleap } from "@/common/functions";

// Remove GTM initialization since it's now in the root config
// Use the existing GTM instance
if (window.dataLayer) {
  Vue.use(VueTagManager, {
    gtmId: process.env.VUE_APP_GTAGMANAGER_ID,
    enabled: false, // Don't initialize again, just use the existing one
  });
}
// const userLoginData = window.localStorage.getItem("login_data")
//   ? JSON.parse(window.localStorage.getItem("login_data"))
//   : null;
Vue.use(VueMeta);

Vue.use(VueLocalStorage, {
  name: "ls",
  bind: true, // created computed members from your variable declarations
});
Vue.use(BootstrapVue);
Vue.use(MailerCloud);
Vue.use(Mixins);
Vue.config.productionTip = false;
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GOOGLE_ANLYTICS,
});
Vue.use(RoutePrefetch);
const vueLifecycles = singleSpaVue({
  Vue,
  appOptions: {
    render(h) {
      return h(App);
    },
    store,
    router,
    mounted() {
      if (window.localStorage.getItem("isAdmin") === "1") {
        setTimeout(() => {
          let elements = document.getElementsByClassName("cky-consent-bar");
          for (let i = 0; i < elements.length; i++) {
            elements[i].classList.add("d-none");
          }
        }, 3000);
      }
      // if (this.name && this.user) {
      //   this.user.name = this.name
      //   setIntercom(this, this.user)
      // } else {
      //   this.$intercom.shutdown()
      //   this.$intercom.boot()
      // }
      initializeGleap(this);
      // setYandex(this);
      /* if (this.name && this.user) {
        var vm = this
        setTimeout(() => {
          vm.loadHubspotTracking(vm)
        }, 2000)
      } */
    },
  },
});
// Sentry.init({
//   Vue,
//   dsn: process.env.VUE_APP_SENTRY_DSN,
//   integrations: [
//     Sentry.browserTracingIntegration({ router }),
//     Sentry.replayIntegration(),
//   ],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,

//   // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: [
//     process.env.TRACE_PROPAGATION_TARGET_1,
//     new RegExp(process.env.TRACE_PROPAGATION_TARGET_2),
//     new RegExp(process.env.TRACE_PROPAGATION_TARGET_3),
//     new RegExp(process.env.TRACE_PROPAGATION_TARGET_4),
//   ],

//   // Capture Replay for 10% of all sessions,
//   // plus for 100% of sessions with an error
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1.0,
// });
// Sentry.setUser({
//   id: userLoginData?.cid,
// });
// Sentry.setTag("plan_type", userLoginData?.plan);

const cssConfig = {
  webpackExtractedCss: false,
  shouldUnmount: true,
  timeout: 15000,
  createLink(url) {
    const linkEl = document.createElement("link");
    linkEl.rel = "stylesheet";
    linkEl.href = url;
    return linkEl;
  },
};
if (process.env.NODE_ENV === "production") {
  cssConfig.cssUrls = [
    process.env.VUE_APP_VUE2_APP_URL +
      "/css/app.css?v=" +
      process.env.VUE_APP_CSS_VERSION,
  ];
}
const cssLifecycles = singleSpaCss(cssConfig);

// Export an array of lifecycles to integrate with a framework's
// single-spa lifecycles. The order matters.
export const bootstrap = [cssLifecycles.bootstrap, vueLifecycles.bootstrap];

export const mount = [
  // The CSS lifecycles should be before your framework's mount lifecycle,
  // to avoid a Flash of Unstyled Content (FOUC)
  cssLifecycles.mount,
  vueLifecycles.mount,
];

export const unmount = [vueLifecycles.unmount, cssLifecycles.unmount];
